export function dataUndefined(data: string | number | Date | null | undefined): string | number {
  let setData: string | number = data as any;

  if (
    data === undefined ||
    data === null ||
    data === "" ||
    data === "undefined"
  ) {
    setData = "-";
  }

  if (data instanceof Date) {
    setData = data.toLocaleDateString();
  }

  return setData;
}

export function dateVerify(data: string | number | Date | null | undefined) {
  let setData = data;

  if (data === undefined || data === null || Number(data) < 0) {
    setData = "-";
  }

  return setData;
}

export function dataZero(data: number | null | undefined) {
  let setData = data;

  if (data === undefined || data === null) {
    setData = 0;
  }

  return setData;
}
